import { StageGateModalComponent } from './modules/workflow/components/stage-gate-modal/stage-gate-modal.component';
import { ChangeDetectorRef, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NotyfService } from './core/services/notyf.service';
import Echo from 'laravel-echo';
import { appEnv } from './app.config';
import { method, set } from 'lodash';
import { TransactionHeaderService } from './core/services/transaction-header.service';
import { BehaviorSubject, catchError, filter, map, of, Subject, Subscription, takeUntil } from 'rxjs';
import { SideBarComponent } from './core/components/side-bar/side-bar.component';
import { CallConsoleComponent } from './modules/messaging/components/call-console/call-console.component';
import { SmsChatConsoleComponent } from './modules/messaging/components/sms-chat-console/sms-chat-console.component';
import { MessageToastComponent } from './core/components/message-toast/message-toast.component';
import { NgxLoadingModule } from 'ngx-loading';
import { CookieService } from 'ngx-cookie-service';
import { CommonResourceService } from './core/services/common-resource.service';
import Pusher from 'pusher-js';
import { WebsocketService } from './core/services/v3/websocket.service';
import { ShipmentService } from './core/services/v3/shipment.service';
import { ShiftService } from './core/services/v3/shift.service';
import { ResponseModel } from './core/models/response.model';
import { DataService } from './modules/consignments-v3/services/data.service';
import { CustomerBranchService } from './core/services/v3/customer-branch.service';
import { AuthService as SupplierAuthService } from './core/services/v3/supplier/auth.service';
import { ToastContainerComponent } from './core/services/v3/toast-container/toast-container.component';

interface RecentRegistration {
  uuid: string;
  name: string;
  contactName: string | null;
  email: string | null;
  createdAt: string | null;
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, CommonModule, SideBarComponent, MessageToastComponent, NgxLoadingModule, CallConsoleComponent, SmsChatConsoleComponent, StageGateModalComponent,
    ToastContainerComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Custm Admin';
  isLoggedIn = false;
  isLoggedInSubject = new Subject<any>;
  isStandAlonePage = false;
  isLoading: boolean = false;
  url = '';
  tokenInterval!: any;
  authDetails: any = {};
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('sideNavigation', {static: false}) sideNavigation!: ElementRef;
  @ViewChildren('sideNavBarDropdown') sideNavBarDropdown!: QueryList<any>;
  private echo?: Echo<any>;
  isDropdownVisibleMachshipNotif: boolean = false;
  intervalGetTransaction: any;
  getMachshipTimer: number = 180000; /* 5mins */
  tokenCheckerInterval: number = 300000; //refresh token every 15minutes
  showOpenSideBarIcon: boolean = false;
  isShowSidebar: boolean = false;
  isShowDropDownSignout: boolean = false;
  hasNewlyAddedMachshipData: boolean = false;
  isFetchingMachshipNewNotif: boolean = true;
  isEcommerceContent: boolean = false;

  /** Customer CRM registration bell - see loadRecentRegistrations(). */
  /** Hidden for now (top bar building icon); set true to bring it back. */
  readonly showRegistrationBell = false;
  isDropdownVisibleRegistrationNotif: boolean = false;
  isFetchingRegistrations: boolean = true;
  recentRegistrations: RecentRegistration[] = [];
  private registrationPollInterval: any;
  private readonly lastSeenRegistrationKey = 'crm_last_seen_registration_at';



  isShowProfileSetting: boolean = false;
  hoveredSignout: boolean = false;
  isSupplierContent = false;
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    const parentClassList = event.srcElement.parentElement?.classList;
    const target = event.target as HTMLElement;
    if (this.isDropdownVisibleMachshipNotif && (!parentClassList.contains('dropdown-menu-header') && !parentClassList.contains('machship-dropdownheader'))) {
      this.isDropdownVisibleMachshipNotif = false;
    }

    if (!target.closest('.cstm-nav-list') && !target.classList.contains('top-nav-toggle')) {
      this.isShowDropDownSignout = false;
    }

    if (this.isDropdownVisibleRegistrationNotif && !target.closest('.registration-notif-container')) {
      this.isDropdownVisibleRegistrationNotif = false;
    }
  }

  constructor (
    private authService: AuthService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private notyf: NotyfService,
    private transaction: TransactionHeaderService,
    private cookieService: CookieService,
    private commonResourceService: CommonResourceService,
    private wsService: WebsocketService,
    private shipmentService: ShipmentService,
    private shiftService: ShiftService,
    private consignmentService: DataService,
    private customerBranchService: CustomerBranchService,
    private zone: NgZone,
    private supplierAuthService: SupplierAuthService
  ) {
    this.router.events.pipe(
      filter((event: any): event is NavigationStart | NavigationEnd => 
        event instanceof NavigationStart || event instanceof NavigationEnd
      )
    ).subscribe((event: NavigationStart | NavigationEnd) => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
        return;
      }

      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/supplier-portal') || event.url.includes('/auth/supplier/callback') || event.url == '/supplier-login') {
            this.isSupplierContent = true;
            const isStandAloneSupplierComponent = event.url.includes('/auth/supplier/callback') || event.url.includes('supplier-portal/driver-registration');
            if (isStandAloneSupplierComponent) return;

            const validSupplierToken = this.supplierAuthService.isValidToken();

            if (!validSupplierToken) {
                // Token is invalid: redirect to login if not already there
                if (!event.url.includes('supplier-login')) {
                    this.router.navigate(['supplier-login']);
                }
            } else {
                // Token is valid: only redirect to 'supplier' if they are on the login page.
                // Otherwise, let them access sub-routes like /supplier/test freely!
                if (event.url.includes('supplier-login')) {
                    this.router.navigate(['supplier-portal']);
                }
            }
            return;
        }
        this.isLoading = false;
        const cookieCustmValue = this.cookieService.get('is-custm-user');
        const isRecentCustmUser: { ok: number; email: string } = cookieCustmValue ? JSON.parse(cookieCustmValue) : { ok: 0, email: '' };
        if (event.url === '/' || event.url === '' || event.url == '/login') {
          //check if the user recently logged in from custm-admin-panel
          // if (isRecentCustmUser.ok) {
            //for now redirect in custm-login when user type {domain}/
            window.location.href = '/custm-login'
            return;
          // }
        }
        const currentUrl = event.urlAfterRedirects || event.url;
        this.isEcommerceContent = currentUrl.includes('ecommerce');
        if (currentUrl === '' || currentUrl === '/') {
          this.router.navigate(['/invalid-page']);
          return;
        }

        const isStandalone =
          currentUrl.includes('reset-password') ||
          /^\/view-route\/\d+$/.test(currentUrl) ||
          currentUrl.includes('auth/callback') ||
          currentUrl.includes('route-planner') ||
          currentUrl.includes('auth/ecommerce/callback') ||
          currentUrl.includes('auth/supplier/callback') ||
          currentUrl.includes('invalid-page') ||
          currentUrl.includes('ecommerce-login') ||
          currentUrl.includes('custm-login') ||
          currentUrl.includes('shift-tracking') ||
          currentUrl.includes('shipment-tracking') ||
          // Public self-service registration - same reason as custm-login
          // above: no sidebar/admin chrome, and must render for an
          // unauthenticated visitor.
          currentUrl.includes('/registration') ||
          // Public Workflow > Forms page (not /workflow/forms - that's the admin editor).
          /^\/forms\//.test(currentUrl) ||
          // Training Modules share links - open for guests (public courses) and signed-in staff alike.
          /^\/training\/c\//.test(currentUrl) ||
          // The forms studio - the editor full-screen in its own tab (signed in; the API
          // interceptor reads the token itself).
          /^\/form-studio\//.test(currentUrl);

        this.isStandAlonePage = isStandalone;

        if ((this.authService.authCheck() || this.authService.authCheckEcommerce()) && !isStandalone && !currentUrl.includes('login')) { //validate custm-login token
          if (this.authService.authCheck()) {
            this.authService.setAuth(localStorage.getItem('custm_token'));
            this.authDetails = JSON.parse(localStorage.getItem('user_details') ?? '');
          }
          if (!this.commonResourceService.initiated()) {
            this.commonResourceService.getAll();
          }
          if (this.showRegistrationBell && !this.registrationPollInterval) {
            this.loadRecentRegistrations();
            this.registrationPollInterval = setInterval(() => this.loadRecentRegistrations(), 60000);
          }
        }

        if (this.isEcommerceContent) {
          const authEcommerce = this.authService.authCheckEcommerce();
          if (!authEcommerce) {
            if (event.url.includes('/track-shipment')) return;
            this.router.navigate(['ecommerce-login']);
            return;
          }
          this.authService.setEcommerceModels();
          if (currentUrl === '/ecommerce-login') {
              this.router.navigate(['ecommerce']);
            }
          return;
        } else {
          if (this.authService.authCheck()) {
            this.isLoggedIn = true;
            this.isLoggedInSubject.next(true);
            if (currentUrl === '/custm-login') {
              this.router.navigate(['financial-dashboard']);
            }
          } else {
            /* Unauthenticated */
            this.isLoggedIn = false;
            this.isLoggedInSubject.next(false);
            this.authService.removeAuth();
            return;
          }
          // Active sidebar link handler
          if (this.sideNavigation) {
            this.sideNavigation.nativeElement.querySelectorAll('.sidebar-nav > .sidebar-item').forEach((element: any) => {
              element.classList.remove('active');
              const redirection = element.querySelector('.route-url')?.getAttribute('href');

              if (redirection) {
                const navPathName = redirection.split('/')[1] ?? '';
                const activeRoutePathName = currentUrl.split('/')[1] ?? '';

                if (navPathName && activeRoutePathName && navPathName === activeRoutePathName) {
                  element.classList.add('active');
                  const dropdown = element.querySelector('.sidebar-dropdown');
                  if (dropdown) {
                    dropdown.classList.add('show');
                  }
                }
              }
            });
          }
        }
      }
      
      this.cd.detectChanges();
    });
  }

  ngOnInit(): void {
    if (this.authService.authCheck()) {
      //initialize refresh token interval
      this.initRefreshTokenInterval();
    }
  }

  ngOnDestroy () {
    this.isLoggedInSubject.unsubscribe();
    clearInterval(this.intervalGetTransaction);
    clearInterval(this.tokenInterval);
    clearInterval(this.registrationPollInterval);
  }

  public get authEcommerce () {
    return this.authService.authInfo;
  }

  public get isEcommerce () {
    return this.authService.isEcommerce;
  }

  cleanUp () {
    this.wsService.echo.leave('ws-auth-user');
  }

  broadcastTransaction () {
    const ws = this.wsService;
    ws.initWebsocket();
    if (ws.echo instanceof Echo) {
      ws.wsAuthChannel
      .listen('.available-machships', (e: any) => {
        const consignment = e.payloads;
        if (Object.keys(consignment).length) {
          if (consignment.is_removed) {
            this.consignmentService.removeFromAvailableMachshipNotif(consignment.id);
          } else {
            this.consignmentService.setAvailableMachship({
              consignmentId: consignment.id,
              startDate: consignment.earliest_pickup,
              clientName: `${consignment?.customer_branch?.customer_profile?.business_name ? `${consignment?.customer_branch?.customer_profile?.business_name} - ` : ''}${consignment.customer_branch.name}`,
              pickUpAddress: consignment?.pick_up_stop?.address_name || '',
              consignmentNumber: consignment.consignment_number || '',
              isCurrentlyInserted: true
            }, true);
            this.hasNewlyAddedMachshipData = true;
          }
        }
      });
    }
  }

  initRefreshTokenInterval() {
    this.checkAndRefreshToken();
    this.zone.runOutsideAngular(() => {
      this.tokenInterval = setInterval(() => {
        this.zone.run(() => {
          this.checkAndRefreshToken();
        });
      }, this.tokenCheckerInterval);
    });
  }

  private checkAndRefreshToken() {
    const token = this.authService.adminToken();
    const tokenExpDate = token ? this.authService.getTokenExpirationDate(token) : null;
    const diffMinutes = tokenExpDate 
      ? (new Date(tokenExpDate).getTime() - Date.now()) / 60000 
      : 0;

    if (diffMinutes <= 15) {
      this.refreshToken();
    }
  }

  refreshToken () {
    this.authService.refreshToken();
  }

  onSignOut () {
    this.authService.signOutMs().subscribe({
      next: (_response: any) => {
        if (_response.success) {
          clearInterval(this.tokenInterval);
          this.authService.removeAuth();
          window.location.href = window.origin+'/custm-login';
        }
      },
      error: (_response: HttpErrorResponse) => {
        this.notyf.notifyError(_response.error?.message || 'Something went wrong processing this request');
      }
    });
  }

  onOpenRosterRoute (data: any) {
    const urlSegment = this.router.url.split('/');
    if (urlSegment[1] !== 'consignments') {
      this.router.navigate(['consignments']);
    }
  }

  onToggleDropdown () {
    this.isDropdownVisibleMachshipNotif = !this.isDropdownVisibleMachshipNotif;
  }

  /* ---------------- Customer CRM registration bell ---------------- */

  loadRecentRegistrations () {
    // this.customerBranchService.getRecentRegistrations().pipe(
    //   catchError(() => of(null))
    // ).subscribe(res => {
    //   this.isFetchingRegistrations = false;
    //   if (res?.success) this.recentRegistrations = res.data as RecentRegistration[];
    // });
  }

  /** A registration counts as "new" if it's newer than the last one the
   *  admin actually opened the bell to look at - persisted so the badge
   *  survives a page refresh instead of resetting every reload. */
  get hasNewRegistration (): boolean {
    if (!this.recentRegistrations.length) return false;
    const lastSeen = localStorage.getItem(this.lastSeenRegistrationKey);
    const newest = this.recentRegistrations[0]?.createdAt;
    if (!newest) return false;
    return !lastSeen || new Date(newest) > new Date(lastSeen);
  }

  onToggleRegistrationDropdown () {
    this.isDropdownVisibleRegistrationNotif = !this.isDropdownVisibleRegistrationNotif;
    if (this.isDropdownVisibleRegistrationNotif && this.recentRegistrations[0]?.createdAt) {
      localStorage.setItem(this.lastSeenRegistrationKey, this.recentRegistrations[0].createdAt);
    }
  }

  openRegistration (registration: RecentRegistration) {
    this.isDropdownVisibleRegistrationNotif = false;
    this.router.navigate(['/crm/customer', registration.uuid]);
  }

  public get availableTransactions () {
    return this.consignmentService.availableMachshipTransaction;
  }

  getAvailableMachships () {
    this.shipmentService.getAvailableMachships().pipe(
      map((response: ResponseModel) => {
        return response;
      }),catchError(error => {
        console.log(error)
        return [];
      })
    ).subscribe(response => {
      this.isFetchingMachshipNewNotif = false;
      if (response.success && response.data.length) {
        (response.data as Array<any>).map(machship => {
          this.consignmentService.setAvailableMachship(
            {
              consignmentId: machship.id,
              startDate: machship.earliest_pickup,
              clientName: `${machship?.customer_branch?.customer_profile?.business_name ? `${machship?.customer_branch?.customer_profile?.business_name} - ` : ''}${machship.customer_branch.name}`,
              pickUpAddress: machship.pick_up_stop?.address_name || '',
              consignmentNumber: machship.consignment_number || ''
            }
          )
        });
      }
    });
  }

  /** Triggers the backend sweep that fills empty charge/pay rate fields (shifts, consignments and jobs) with 0. Fire-and-forget, once per app load. */
  runEmptyRateCleanup () {
    this.shiftService.fixEmptyRates().pipe(
      catchError(error => {
        console.log(error);
        return [];
      })
    ).subscribe();

    this.shipmentService.fixEmptyRates().pipe(
      catchError(error => {
        console.log(error);
        return [];
      })
    ).subscribe();
  }

  switchToPortalAuth () {
    this.authService.switchToPortal();
  }

  toggleProfileSetting () {
    this.isShowProfileSetting = !this.isShowProfileSetting;
  }
}
